<template>
  <!-- 开盘时间 -->
  <div class="opening-time-page">
    <!-- 页面顶部 Header -->
    <div class="page-header">
      <div class="header-left">
        <span class="page-title">系统配置</span>
        <el-tag size="small" type="info" effect="plain" class="title-tag">参数管理</el-tag>
      </div>
    </div>

    <!-- 配置 Tabs -->
    <el-card class="content-card" shadow="never">
      <el-tabs v-model="activeName" @tab-click="handleClick" class="config-tabs">
        <!-- 通证配置 -->
        <el-tab-pane name="first">
          <span slot="label"><i class="el-icon-coin"></i> 通证配置</span>
          <div class="tab-content">
            <div class="section-title">
              <i class="el-icon-coin"></i>
              <span>通证手续费配置</span>
            </div>
            <el-form size="medium" label-width="160px" class="config-form">
              <el-row :gutter="32">
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="转出手续费">
                    <el-input v-model="value.tokenOutChange" type="number" placeholder="请输入转出手续费"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="转入手续费">
                    <el-input v-model="value.tokenChange" type="number" placeholder="请输入转入手续费"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="互转手续费">
                    <el-input v-model="value.tokenExChange" type="number" placeholder="请输入互转手续费"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="结算手续费">
                    <el-input v-model="value.accountChange" type="number" placeholder="请输入结算手续费"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="充值CNY手续费">
                    <el-input v-model="value.popChange" type="number" placeholder="请输入充值CNY手续费"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="分红1仓释放比例">
                    <el-input v-model="value.openRate" type="number" placeholder="请输入分红1仓释放比例"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="分红2仓释放比例">
                    <el-input v-model="value.openRate2" type="number" placeholder="请输入分红2仓释放比例"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="回购释放比例">
                    <el-input v-model="value.openRatePool" type="number" placeholder="请输入回购释放比例"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div class="form-actions">
              <el-button type="primary" icon="el-icon-check" @click="onTime('Token')">提交保存</el-button>
            </div>
          </div>
        </el-tab-pane>

        <!-- 交易配置 -->
        <el-tab-pane name="second">
          <span slot="label"><i class="el-icon-data-line"></i> 交易配置</span>
          <div class="tab-content">
            <div class="section-title">
              <i class="el-icon-time"></i>
              <span>开盘时间与手续费</span>
            </div>
            <el-form size="medium" label-width="160px" class="config-form">
              <el-row :gutter="32">
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="开盘时间">
                    <el-time-picker is-range v-model="times" range-separator="至" start-placeholder="开始时间"
                      end-placeholder="结束时间" placeholder="选择时间范围" format="HH:mm:ss" value-format="HH:mm:ss"
                      style="width: 100%">
                    </el-time-picker>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="委托交易手续费">
                    <el-input v-model.number="value.buyToken" type="number" placeholder="请输入委托交易手续费"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <div class="section-title">
              <i class="el-icon-set-up"></i>
              <span>开关状态控制</span>
            </div>
            <el-form size="medium" label-width="160px" class="config-form">
              <el-row :gutter="32">
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="提现">
                    <el-radio-group v-model="value.withdrawStatus">
                      <el-radio :label="1">提现开启</el-radio>
                      <el-radio :label="2">提现关闭</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="充值">
                    <el-radio-group v-model="value.popupStatus">
                      <el-radio :label="1">充值开启</el-radio>
                      <el-radio :label="2">充值关闭</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="流转">
                    <el-radio-group v-model="value.tokenStatus">
                      <el-radio :label="1">流传开启</el-radio>
                      <el-radio :label="2">流传关闭</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="cny转出时间">
                    <el-radio-group v-model="value.cnyTime">
                      <el-radio label="1">开启</el-radio>
                      <el-radio label="2">关闭</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="是否开盘">
                    <el-radio-group v-model="value.status">
                      <el-radio :label="1">开盘</el-radio>
                      <el-radio :label="2">未开盘</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="结算">
                    <el-radio-group v-model="value.accountStatus">
                      <el-radio :label="1">开启</el-radio>
                      <el-radio :label="2">关闭</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div class="form-actions">
              <el-button type="primary" icon="el-icon-check" @click="onTime('transaction')">提交保存</el-button>
            </div>
          </div>
        </el-tab-pane>

        <!-- 充值配置 -->
        <el-tab-pane name="third">
          <span slot="label"><i class="el-icon-wallet"></i> 充值配置</span>
          <div class="tab-content">
            <div class="section-title">
              <i class="el-icon-wallet"></i>
              <span>充值额度与手续费</span>
            </div>
            <el-form size="medium" label-width="160px" class="config-form">
              <el-row :gutter="32">
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="最小充值额度">
                    <el-input v-model="value.popUp" type="number" placeholder="请输入最小充值额度"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="低于充值额度手续费">
                    <el-input v-model="value.popChange" type="number" placeholder="请输入低于充值额度手续费"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div class="form-actions">
              <el-button type="primary" icon="el-icon-check" @click="onTime('recharge')">提交保存</el-button>
            </div>
          </div>
        </el-tab-pane>

        <!-- 提现配置 -->
        <el-tab-pane name="fourth">
          <span slot="label"><i class="el-icon-bank-card"></i> 提现配置</span>
          <div class="tab-content">
            <div class="section-title">
              <i class="el-icon-bank-card"></i>
              <span>提现规则配置</span>
            </div>
            <el-form size="medium" label-width="160px" class="config-form">
              <el-row :gutter="32">
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="提现手续费">
                    <el-input v-model="value.withdrawChange" type="number" placeholder="请输入提现手续费"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="提现最大额度">
                    <el-input v-model="value.withdrawMaxAmount" type="number" placeholder="请输入提现最大额度"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="提现最小额度">
                    <el-input v-model="value.withdrawMinAmount" type="number" placeholder="请输入提现最小额度"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="提现的最大笔数">
                    <el-input v-model="value.withdrawMaxNum" type="number" placeholder="请输入提现最大笔数"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="提现倍数">
                    <el-input v-model="value.withdrawRate" type="number" placeholder="请输入提现倍数"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div class="form-actions">
              <el-button type="primary" icon="el-icon-check" @click="onTime('Withdrawal')">提交保存</el-button>
            </div>
          </div>
        </el-tab-pane>

        <!-- 锁仓配置 -->
        <el-tab-pane name="rock">
          <span slot="label"><i class="el-icon-lock"></i> 锁仓配置</span>
          <div class="tab-content">
            <div class="section-title">
              <i class="el-icon-lock"></i>
              <span>锁仓规则配置</span>
            </div>
            <el-form size="medium" label-width="160px" class="config-form">
              <el-row :gutter="32">
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="全部锁仓比例">
                    <el-input v-model="value.closeRate" type="number" placeholder="请输入全部锁仓比例"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="最低保证金">
                    <el-input v-model="value.closeMinAmount" type="number" placeholder="请输入最低保证金"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div class="form-actions">
              <el-button type="primary" icon="el-icon-check" @click="onTime('recharge')">提交保存</el-button>
            </div>
          </div>
        </el-tab-pane>

        <!-- gen 互转配置 -->
        <el-tab-pane name="genPZ">
          <span slot="label"><i class="el-icon-refresh"></i> gen互转配置</span>
          <div class="tab-content">
            <div class="section-title">
              <i class="el-icon-refresh"></i>
              <span>gen 互转配置</span>
            </div>
            <el-form size="medium" label-width="160px" class="config-form">
              <el-row :gutter="32">
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="gen转出最大值">
                    <div class="input-with-btn">
                      <el-input v-model="genBig" type="number" placeholder="请输入gen转出最大值"></el-input>
                      <el-button type="primary" icon="el-icon-check" @click="genSub('1')">保存</el-button>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="gen转出最小值">
                    <div class="input-with-btn">
                      <el-input v-model="genSmall" type="number" placeholder="请输入gen转出最小值"></el-input>
                      <el-button type="primary" icon="el-icon-check" @click="genSub('2')">保存</el-button>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :md="12" :sm="24">
                  <el-form-item label="gen状态">
                    <el-switch v-model="genStatus" class="gen-status" :active-value="1" :inactive-value="2"
                      active-text="开" inactive-text="关" v-loading="isLoading" @change="handleSwitchChange">
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>

        <!-- 建仓配置 -->
        <el-tab-pane name="jcPZ">
          <span slot="label"><i class="el-icon-office-building"></i> 建仓配置</span>
          <div class="tab-content">
            <div class="section-title">
              <i class="el-icon-office-building"></i>
              <span>建仓限额配置</span>
            </div>
            <el-form size="medium" label-width="220px" class="config-form">
              <el-row :gutter="32">
                <el-col :xl="12" :lg="12" :md="14" :sm="24">
                  <el-form-item label="用户每天最多允许建仓总量">
                    <div class="input-with-btn">
                      <el-input v-model="maxPositionNum" type="number" placeholder="请输入用户每天最多允许建仓总量"></el-input>
                      <el-button type="primary" icon="el-icon-check" @click="saveJc()">保存</el-button>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: {},
      times: [],
      // cnyTime:[],
      id: '',
      activeName: 'first',
      genBig: null,
      genSmall: null,
      genStatus: null,
      // 记录开关将要切换到的状态
      pendingStatus: null,
      // 加载状态
      isLoading: false,
      // 建仓数量
      maxPositionNum: 0
    }
  },
  created() {
    this.axios.get('/admin/openClose/show', {}).then(res => {
      let arr = res.data.data[0]
      this.value = res.data.data[0]
      this.times.push(arr.openTime)
      this.times.push(arr.closeTime)
      this.genBig = arr.transferGenMax
      this.genSmall = arr.transferGenMin
      this.genStatus = arr.transferGenStatus
      // this.cnyTime=this.value.cnyTime.split('-')
      this.maxPositionNum = arr.maxPositionNum
      console.log(this.value)
    })
  },
  methods: {
    // 建仓保存
    saveJc() {
      if (!this.maxPositionNum) {
        this.$message("请输入用户每天最多允许建仓总量")
        return
      }
      this.axios.get('/admin/openClose/updateMaxPositionNum', {
        maxPositionNum: this.maxPositionNum
      }).then(res => {
        if (res.data.code == '200') {
          this.$message.success('保存成功');
        } else {
          // 接口返回失败，不更新状态
          this.$message.error('保存失败: ' + (res.data.mesg || '未知错误'));
        }
      })
    },
    // 操作最大值最小值
    genSub(type) {
      if (type == '1') {
        if (!this.genBig) {
          this.$message("请输入gen转出最大值")
          return
        }
        this.axios.get('/admin/openClose/updateMax', {
          num: this.genBig
        }).then(res => {
          if (res.data.code == '200') {
            this.$message.success('保存成功');
          } else {
            // 接口返回失败，不更新状态
            this.$message.error('保存失败: ' + (res.data.mesg || '未知错误'));
          }
        })
      } else {
        if (!this.genSmall) {
          this.$message("请输入gen转出最小值")
          return
        }
        this.axios.get('/admin/openClose/updateMin', {
          num: this.genSmall
        }).then(res => {
          if (res.data.code == '200') {
            this.$message.success('保存成功');
          } else {
            // 接口返回失败，不更新状态
            this.$message.error('保存失败: ' + (res.data.mesg || '未知错误'));
          }
        })
      }
    },
    async handleSwitchChange(newStatus) {
      // 保存将要切换到的状态
      this.pendingStatus = newStatus;
      // 显示加载状态
      this.isLoading = true;

      try {
        // 调用接口
        const response = await this.axios
          .get('/admin/openClose/updateTransferGenStatus', {
            status: newStatus,
          })
        // 接口调用成功，更新开关状态
        if (response.data.code == '200') {
          this.switchStatus = newStatus;
          this.$message.success('操作成功');
        } else {
          // 接口返回失败，不更新状态
          this.$message.error('操作失败: ' + (response.data.mesg || '未知错误'));
        }
      } catch (error) {
        // 接口调用失败，不更新状态
        this.$message.error('操作失败');
        console.error('接口调用错误:', error);
      } finally {
        // 关闭加载状态
        this.isLoading = false;
        this.pendingStatus = null;
      }
    },
    onTime(type) {
      // console.log(this.cnyTime)
      if (this.value.tokenChange < 0 || this.value.tokenExChange < 0 || this.value.tokenOutChange < 0) {
        this.$message({
          type: 'error',
          message: '手续费需大于0'
        })
      } else if (
        this.value.withdrawChange < 0 ||
        this.value.withdrawMaxAmount <= 0 ||
        this.value.withdrawMinAmount <= 0 ||
        this.value.withdrawMaxNum <= 0 ||
        this.value.withdrawRate <= 0 ||
        this.value.accountChange <= 0
      ) {
        this.$message({
          type: 'error',
          message: '请输入大于0的数字'
        })
      } else {
        this.axios
          .post('/admin/openClose/update', {
            id: this.value.id,
            openTime: this.times[0].toString(),
            closeTime: this.times[1].toString(),
            buyToken: this.value.buyToken,
            status: this.value.status,
            tokenChange: this.value.tokenChange,
            tokenExChange: this.value.tokenExChange,
            tokenOutChange: this.value.tokenOutChange,
            withdrawStatus: this.value.withdrawStatus,
            popupStatus: this.value.popupStatus,
            tokenStatus: this.value.tokenStatus,
            tokenMin: this.value.tokenMin,
            withdrawChange: this.value.withdrawChange,
            popChange: this.value.popChange,
            popUp: this.value.popUp,

            withdrawMaxNum: this.value.withdrawMaxNum,
            withdrawMaxAmount: this.value.withdrawMaxAmount,
            withdrawMinAmount: this.value.withdrawMinAmount,
            withdrawRate: this.value.withdrawRate,
            accountChange: this.value.accountChange,
            accountStatus: this.value.accountStatus,
            closeRate: this.value.closeRate,
            closeMinAmount: this.value.closeMinAmount,
            // cnyTime:this.cnyTime[0]+'-'+this.cnyTime[1],
            cnyTime: this.value.cnyTime,
            openRate: this.value.openRate,
            openRate2: this.value.openRate2,
            openRatePool: this.value.openRatePool,
          })
          .then(res => {
            if (res.data.code == 200) {
              if (type == 'Token') {
                this.$message({
                  type: 'success',
                  message: '通证配置修改成功'
                })
              }
              if (type == 'transaction') {
                this.$message({
                  type: 'success',
                  message: '交易配置修改成功'
                })
              }

              if (type == 'recharge') {
                this.$message({
                  type: 'success',
                  message: '充值配置修改成功'
                })
              }

              if (type == 'Withdrawal') {
                this.$message({
                  type: 'success',
                  message: '提现配置修改成功'
                })
              }
            } else {
              this.$message({
                type: 'error',
                message: res.data.mesg
              })
            }
          })
      }
    },
    handleClick(tab, event) {
      console.log(tab, event)
    }
  }
}
</script>

<style lang="scss" scoped>
.opening-time-page {
  padding: 20px 24px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 60px);
  box-sizing: border-box;
}

/* 顶部 Header */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 16px 24px;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.header-left {
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  position: relative;
  padding-left: 12px;
}

.page-title::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 16px;
  background: #409eff;
  border-radius: 2px;
}

.title-tag {
  margin-left: 16px;
}

/* 内容卡片 */
.content-card {
  border-radius: 8px;
  border: 1px solid #ebeef5;
}

.content-card ::v-deep .el-card__body {
  padding: 8px 20px 24px;
}

/* Tabs 样式 */
.config-tabs ::v-deep .el-tabs__header {
  margin: 0 0 24px 0;
  border-bottom: 1px solid #ebeef5;
}

.config-tabs ::v-deep .el-tabs__nav-wrap::after {
  display: none;
}

.config-tabs ::v-deep .el-tabs__item {
  height: 48px;
  line-height: 48px;
  font-size: 14px;
  color: #606266;
  padding: 0 20px;
  transition: all 0.2s ease;

  i {
    margin-right: 4px;
    font-size: 14px;
  }

  &:hover {
    color: #409eff;
  }

  &.is-active {
    color: #409eff;
    font-weight: 600;
  }
}

.config-tabs ::v-deep .el-tabs__active-bar {
  height: 3px;
  border-radius: 2px;
}

/* Tab 内容区 */
.tab-content {
  padding: 8px 4px 0;
}

/* 区块小标题 */
.section-title {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  padding: 0 0 14px;
  margin-bottom: 18px;
  border-bottom: 1px dashed #ebeef5;

  i {
    margin-right: 8px;
    color: #409eff;
    font-size: 16px;
  }
}

.section-title + .config-form + .section-title {
  margin-top: 8px;
}

/* 表单 */
.config-form ::v-deep .el-form-item {
  margin-bottom: 22px;
}

.config-form ::v-deep .el-form-item__label {
  color: #606266;
  font-weight: 500;
}

.config-form ::v-deep .el-input__inner:focus,
.config-form ::v-deep .el-input__inner:hover {
  border-color: #409eff;
}

/* input + 按钮组合 */
.input-with-btn {
  display: flex;
  align-items: center;
  gap: 10px;

  .el-input {
    flex: 1;
  }

  .el-button {
    flex-shrink: 0;
  }
}

/* gen 状态开关 */
.gen-status ::v-deep .el-switch__label {
  color: #909399;
}

.gen-status ::v-deep .el-switch__label.is-active {
  color: #409eff;
}

/* 操作按钮区 */
.form-actions {
  margin-top: 8px;
  padding: 16px 0 4px;
  border-top: 1px solid #ebeef5;
  display: flex;
  justify-content: flex-end;

  .el-button {
    min-width: 120px;
  }
}

/* 响应式 */
@media (max-width: 768px) {
  .opening-time-page {
    padding: 12px;
  }

  .config-tabs ::v-deep .el-tabs__item {
    padding: 0 12px;
    font-size: 13px;
  }
}
</style>
